export const selectData = (state) => state.storages.data
export const selectLoadingStatus = (state) => state.storages.status
export const selectError = (state) => state.storages.error
